define('views/modules/setting/business/modals/payment-modify-plan-modal',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'utils',
    'bootbox',
    'services/i18n',
    'debug',
    'moment',
    //services
    'services/api',
    'services/session',
    'services/toastr-service',
    // views
    'views/parts/modal/modal',
    'views/parts/form/textbox',
    'views/modules/setting/business/list/membership-plan-list',
    'views/modules/setting/business/list/membership-plan-list-item',
    'views/parts/alert/alert-list',
    // templates
    'text!templates/modules/setting/business/modals/payment-modify-plan-modal.html',

], function(
    // Libs
    _, Backbone, Mustache, U, Bootbox, i18n, DEBUG, moment,
    // Services
    API,
    Session,
    ToastrService,
    // views
    VModal,
    VTextbox,
    VMembershipPlanList,
    VMembershipPlanListItem,
    VAlertList,
    //templates
    TPaymentModifyPlanModal
) {
    var VPaymentModifyPlanModal = VModal.extend({
        template: TPaymentModifyPlanModal,
        regions: {
            teamName: '.payment-team-name-section',
            list: "#payment-plan-list",
            alert: ".alert-list",
        },

        modal: function() {
            return {
                closeButton: false,
                title: i18n.t("payment:modify_plan"),
                buttons: {
                    cancelAccount: {
                        label: i18n.t('payment:cancel_account'),
                        className: 'btn-danger',
                        callback: this.onCancelAccountClick,
                    },
                    cancel: {
                        label: i18n.t("Close"),
                        className: 'btn-link'
                    }
                },
            };
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);

            _.extend(this, {
                collection: this.options.planList,
                group: opt.group,
                profile: opt.profile
            });

            var collection = this.collection,
                view = this.view = {
                    teamName: new VTextbox({
                        labelposition: 'top',
                        button: false,
                        model: this.options.teamPaymentModel,
                        attribute: 'name',
                    }),
                    list: new VMembershipPlanList({
                        collection: collection,
                        item: VMembershipPlanListItem,
                        itemOptions: {
                            selectedPlan: this.options.teamPaymentModel.getMembershipPlan(),
                        },
                        async: false,
                    }),
                    alert: new VAlertList({
                        collection: new Backbone.Collection([])
                    })
                };

            this.listenTo(collection, { "payment:select-plan": this.onSelectPlan });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.view.list.updateItemOptions({
                selectedPlan: this.options.teamPaymentModel.getMembershipPlan(),
                teamPaymentCurrency: this.options.teamPaymentModel.getCurrency()
            });

            this.generateZones()
                .assign(this.view.teamName, this.zone.$teamName)
                .assign(this.view.list, this.zone.$list)
                .assign(this.view.alert, this.zone.$alert);


            this.view.teamName.setDisable(true);

            this.renderModal();

            return this;
        },

        show: function() {
            this.render();
        },

        updateOptions: function(options) {
            this.options.teamPaymentModel = options.teamPaymentModel;
            this.options.selectedPlan = options.teamPaymentModel.getMembershipPlan();
        },

        cancelAccount: function(accepted) {
            if (!accepted) return true;
            this.doAjaxRequest();
        },

        doAjaxRequest: function() {
            var url = "users/" + Session.getUserId() + '/cancel';
            Backbone.ajax(
                _.extend({
                    url: API.url(url),
                    method: "POST",
                    data: JSON.stringify({ payment: this.options.teamPaymentModel.get('payment') }),
                    dataType: 'json',
                    contentType: 'application/json',
                    context: this,
                }, {

                    success: function(response) {
                        Session.signOut();
                        ToastrService.success('payment:succesfully-canceled-account');
                    },
                    error: function(response) {
                        ToastrService.error('api-messages:' + U.toApiMessages(response.responseJSON.code));
                    }
                })
            );
        },

        ////////////
        // events //
        ////////////
        onSelectPlan: function(planId) {
            this.view.alert.reset();

            var isPatch = true;
            this.options.teamPaymentModelCarbon = this.options.teamPaymentModel.clone();

            this.options.teamPaymentModel.setMembershipPlan(planId);
            this.options.teamPaymentModel.save(
                _.extend({
                    id: this.options.teamPaymentModel.id
                }, this.options.teamPaymentModel.changed),
                {
                    patch: isPatch,
                    wait: true,
                    context: this,
                    success: function() {
                        this.close();
                    },
                    error: function(model, response, options) {
                        var pendingMembership = model.getMembershipPlan();

                        //Restore values
                        var changedAttributes = Object.keys(this.options.teamPaymentModel.changed);
                        for (var i = 0; i < changedAttributes.length; ++i) {
                            this.options.teamPaymentModel.set(
                                changedAttributes[i],
                                this.options.teamPaymentModelCarbon.get(changedAttributes[i])
                            );
                        }

                        if (response && response.responseJSON) {
                            var errorCode = response.responseJSON.code,
                                message = response.responseJSON.message;

                            if (errorCode) {
                                if (errorCode === "CANNOT_UPDATE_MEMBERSHIP") {
                                    this.close();
                                    this.options.teamPaymentModel.collection.trigger(
                                        "payment:update-method",
                                        this.options.teamPaymentModel,
                                        this,
                                        { pendingMembership: pendingMembership }
                                    );
                                } else {
                                    this.view.alert.reset();
                                    this.view.alert.addError("api-messages:" + errorCode.replace(/_/g, '-'));
                                }
                            }
                        }
                    }
                }
            );
        },

        onChangePlanClick: function() {
        },

        onCancelAccountClick: function() {
            Bootbox.confirm({
                title: i18n.t('payment:cancel_account'),
                message: i18n.t('payment:Cancel account text {{date}}', { date: moment(this.options.group.get('expires')).format("D/M/Y") }),
                onEscape: true,
                backdrop: true,
                callback: this.cancelAccount,
                context: this,
            });
        },

    });

    return VPaymentModifyPlanModal;
});

